module.exports = __webpack_public_path__ + "img/todos_os_santos.e8fd493b.svg";